import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Icons } from "../../../config/MuiIcons.config";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import {
  ERROR_MESSAGE,
  SNACKBAR_VARIANT,
} from "../../../config/Messages.config";
import WarningImage from "../../../assets/images/Warning.svg";

const WarningModalForFinalSave = ({
  Open,
  ToggleFunction,
  OnSubmit,
  ModalType,
  Data,
}) => {
  const { showSnackbar } = useSnackbar();
  const handleClose = () => {
    ToggleFunction("", null);
  };

  const warningMessage =
    ModalType === "Auditor"
      ? "You are about to finalize the audit review. Once submitted, no further changes can be made at this stage."
      : ModalType === "Auditee"
      ? "You are about to finalize your response and submit it for verification. Once submitted, no further changes can be made at this stage."
      : ModalType === "Close Audit"
      ? "Do you want to close this audit?"
      : "";

  return (
    <Dialog
      open={Open}
      aria-labelledby="form-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle style={{ textAlign: "center" }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <Icons.Close />
        </IconButton>
        <img
          src={WarningImage}
          alt="warning-img"
          style={{ width: "45px", height: "45px" }}
        />
      </DialogTitle>
      <DialogContent style={{ textAlign: "center" }}>
        <Typography style={{ fontSize: "24px" }} className="inter-regular-400">
          {ModalType === "Close Audit"
            ? "Are you sure"
            : "Are you sure you want to proceed?"}
        </Typography>
        <Typography style={{ fontSize: "16px" }} className="inter-regular-400">
          {warningMessage}
        </Typography>
      </DialogContent>
      <DialogActions className="justify-content-center mb-3 mx-5">
        <AppButton OnPress={handleClose}>Cancel</AppButton>
        <AppButton
          Color={"error"}
          OnPress={() => {
            if (navigator.onLine) {
              OnSubmit(ModalType, Data);
              handleClose();
            } else {
              showSnackbar(
                ERROR_MESSAGE.INTERNET_ERROR,
                SNACKBAR_VARIANT.ERROR
              );
            }
          }}
        >
          {ModalType === "Close Audit" ? "Close" : "Proceed"}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default WarningModalForFinalSave;
